module.exports = __webpack_public_path__ + "static/media/backgroundDark.58c33377.jpg";